import { render, staticRenderFns } from "./ScrollAnimation.vue?vue&type=template&id=b8d70348&"
import script from "./ScrollAnimation.vue?vue&type=script&lang=js&"
export * from "./ScrollAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports